import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

import { labelTypes } from '@generators/tresholdConstants'
import { Item } from './Item'
import { Line } from './Line'
import { CharacteristicStatus } from './CharacteristicStatus'
import { characteristicMask } from '@util/stringUtil'

const styles = {
  characteristic: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '24px 0',
  },
}

export const HealthCharacteristic = ({ type, value, lineStyle }) => (
  <>
    <div style={styles.characteristic}>
      <Item
        label={labelTypes[type]}
        text={characteristicMask(type, value)}
      />
      <CharacteristicStatus value={value} type={type} />
    </div>
    <Line lineColor={colors.softGray} style={lineStyle} />
  </>
)

HealthCharacteristic.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  lineStyle: PropTypes.object,
}

HealthCharacteristic.defaultProps = {
  lineStyle: null,
}
